import * as moment from 'moment';
import { DepartmentResult } from '../department';
import { Gender } from '../enums';

export class EmployeeResult {
    public id: number = 0;
    public firstName: string = '';
    public lastName: string = '';
    public nationalIdentity: string = '';
    public cellphoneNumber: string = '';
    public email: string = '';
    public username: string = '';
    public gender: Gender = Gender.Male;
    public securityLevel: string = '';
    public personalPictureFileName: string = '';
    public isActive: boolean = false;
    public birthDate: moment.Moment = moment(moment.now(), 'YYYY-MM-DD').utc(false);
    public departmentList: Array<DepartmentResult> = [];
    public isDeleted: boolean = false;
}
